import { Colors } from '@vetahealth/fishing-gear/colors'
import { PatientTask } from '@vetahealth/tuna-can-api'
import dayjs from 'dayjs'
import i18next from 'i18next'

import { BarChart } from '../Chart/BarChart'
import { TaskTable } from '../Table'
import { ResultsConfig } from './types'

export function getRiskScoreConfig(): ResultsConfig {
  const unit = 'min'

  return {
    key: 'riskScore',
    title: i18next.t('tracking.riskScore.title'),
    category: 'task',
    format: (event) => event.value?.toString() ?? '-',
    card: {
      formatTime: () => dayjs().format(i18next.t('dateFormats.monthAndYear')),
      formatTitle: (lastResult) => i18next.t('tracking.riskScore.titleWithName', { name: lastResult?.unit }),
    },
    unit,
    actions: { reviewBulk: true },
    chart: {
      component: BarChart,
      intervals: ['week', 'month', 'trend'],
      dataKeys: [{ key: 'value', color: Colors.plum500 }],
      getData: (data: PatientTask[]) =>
        data.map((item) => ({ ...item, value: item.riskScore ?? 0, id: item.responseId })),
    },
    render: () => <TaskTable type="riskScore" key="riskScore" />,
  }
}
